import { soilUseCase } from "@/api/modules/soil/useCases";
import { managementSectorUseCases } from "@/api/modules/sector/useCases";
import { checkFarmsWithData } from "@/api/modules/farms_dap/useCases/checkFarmsWithData";
import { farmUseCase } from "@/api/modules/farm/useCases";
import store from "@/store";
import { user as userStore } from "@/pages/components/globalstore";
import { alerts, monit, users, sectors, user } from "@/api";
import { cookies } from "@/pages/components/cookies";
import servicesRelations from "./servicesRelations";
// const isAdmin = Number(cookies.get("PERMISSIONS")) == 1;
const getStations = async () => {
  await store.dispatch("fetchPositionInfos");
  const position = store.state.positionInfos;
  const monitStation = await monit.station();
  const hasStation = monitStation.status;

  const installedStation = hasStation
    ? monitStation && monitStation.value && monitStation.value[0]
    : {};

  const installedStationDTO = {
    ID: installedStation.ID,
    NAME: ["DIR", installedStation.ADDR, ...position.NAME.split(" ")].join("-"),
    LATITUDE: installedStation.LATITUDE,
    LONGITUDE: installedStation.LONGITUDE,
    NOTE: installedStation.NOTE,
  };

  const manualStation = {
    ID: 1,
    NAME: ["MANUAL", ...position.NAME.split(" ")].join("-"),
    LATITUDE: position.LATITUDE,
    LONGITUDE: position.LONGITUDE,
    NOTE: "Estação manual",
  };

  let returnedStation = manualStation;

  if (hasStation) {
    returnedStation = installedStationDTO;
  }

  return [[returnedStation]];
};

export const getLockedMessage = ({ element, hasService, hasPermission }) => {
  if (!hasService) {
    return "Serviço não habilitado";
  } else if (!hasPermission) {
    return "Sem permissão";
  } else {
    return "";
  }
};
export const isLocked = ({
  needPermissionId,
  needServiceId,
  userPermissions,
  userServices,
}) => {
  const foundPermission = userPermissions.find((p) => p.id == needPermissionId);
  const foundService = userServices.find((p) => p.id == needServiceId);

  const hasPermission = needPermissionId ? !!foundPermission : true;
  const hasService = needServiceId ? !!foundService : true;

  const isLocked = [hasPermission, hasService].includes(false);
  let lockedMessage = "";
  if (!hasService) {
    lockedMessage = "Serviço não habilitado";
  } else if (!hasPermission) {
    lockedMessage = "Sem permissão";
  }

  return [isLocked, lockedMessage];
};

export const routes = [
  {
    routeName: "monitoring",
    componentName: "DomainPageTemplate",
    path: "/monitoring",
    needPermissionId: null,
    needServiceId: null,
    title: "Monitorar",
    icon: "eye-icon",
    description: "Monitorar",
    accentColor: "var(--green-3v3)",
    props: {
      pageTitle: "Monitorar",
      routesIndex: 0,
    },
    nestedRoutes: [
      {
        routeName: "monitoring-schedule",
        componentName: "MonitScdl",
        path: "/schedule",
        needPermissionId: 1,
        needServiceId: null,
        title: "agendas",
        icon: "calendar-clock-icon",
        description: "Monitore o progresso das agendas cadastradas",
      },
      {
        routeName: "monitoring-actuators",
        componentName: "MonitEqps",
        path: "/actuators",
        needPermissionId: 2,
        needServiceId: null,
        title: "atuadores",
        icon: "water-icon",
        description: "Monitore válvulas, bombas e demais atuadores",
      },
      {
        routeName: "monitoring-sensors",
        componentName: "MonitSnrs",
        path: "/sensors",
        needPermissionId: null,
        needServiceId: null,
        title: "sensores",
        icon: "gauge-icon",
        description: "Monitore sensores e hidrômetros instalados",
      },
      {
        routeName: "monitoring-dirs",
        componentName: "MonitDirs",
        path: "/dirs",
        needPermissionId: 4,
        needServiceId: null,
        title: "dispositivos",
        icon: "dir-icon",
        description: "Monitore status de bateria e comunicação",
      },
      {
        routeName: "charts",
        componentName: "Charts",
        path: "/charts",
        needPermissionId: 12,
        needServiceId: null,
        title: "Gráficos",
        icon: "chart-icon",
        description: "Gere gráficos de equipamentos",
      },
      {
        routeName: "monitoring-map",
        componentName: "",
        path: "/map",
        needPermissionId: 13,
        needServiceId: null,
        title: "mapa",
        redirect: "/monitoring",
        redirectTo: "/map-view",
        icon: "map-marker-icon",
        description: "Monitore equipamentos georreferenciados",
      },
      {
        routeName: "monitoring-station",
        componentName: "Station",
        path: "/station",
        needPermissionId: 14,
        needServiceId: null,
        title: "Estação",
        icon: "station-icon",
        description: "Monitore EMR local, calcule ET0",
      },
      {
        routeName: "monitoring-sector",
        componentName: "SectorMonitoring",
        path: "/sector",
        needPermissionId: 16,
        needServiceId: servicesRelations.management,
        title: "setores",
        icon: "sector-icon",
        description: "Monitore status de setor",
      },
    ],
  },
  {
    routeName: "registers",
    componentName: "DomainPageTemplate",
    props: {
      pageTitle: "Cadastrar",
      routesIndex: 1,
    },
    path: "/registers",
    needPermissionId: null,
    needServiceId: null,
    title: "Cadastrar",
    icon: "pencil-icon",
    description: "Cadastrar",
    // accentColor: "var(--green-3v3)",
    accentColor: "var(--orange-color-tertiary)",
    nestedRoutes: [
      {
        componentName: "Schedule",
        routeName: "registers-schedule",
        path: "/schedule",
        title: "agendas",
        icon: "calendar-clock-icon",
        needPermissionId: 1,
        needServiceId: null,
        description: "Cadastre agendas",
      },
      // {
      //   componentName: 'RegisterPageTemplate',
      //   path: "/schedule",
      //   routeName: "registers-schedule",
      //   needPermissionId: 1,
      //   needServiceId: null,
      //   title: "agendas",
      //   icon: "calendar-clock-icon",
      //   description: "Cadastre agendas",
      //   props: {
      //     pageTitles: ['Cadastrar', 'Agendas'],
      //     selectedTitle: "agendas",
      //     cardTags: [
      //       // {
      //       //   icon: "code-not-equal-icon",
      //       //   title: 'Setor de manejo',
      //       //   tagValidator: (item) => item.IS_MANAGEMENT,
      //       //   class: "text-success"
      //       // }
      //     ],
      //     columns: [
      //       {
      //         title: 'Dias ativos',
      //         key: 'ACTIVITY_DAYS',
      //         icon: '',
      //         measurement: '',
      //         format: 'schedule'
      //       },
      //       {
      //         title: 'Início',
      //         key: 'START_FULL_FORMATTED',
      //         icon: '',
      //         measurement: '',
      //         format: 'date'
      //       },
      //       {
      //         title: 'Expira',
      //         key: 'END_FULL_FORMATTED',
      //         icon: '',
      //         measurement: '',
      //         format: 'date'
      //       },
      //       {
      //         title: 'Data de Atualização',
      //         key: 'UPDATE',
      //         icon: '',
      //         // icon: 'calendar-icon',
      //         measurement: '',
      //         format: 'date'
      //       },
      //       {
      //         title: 'Nome do editor',
      //         key: 'EDITOR_NAME',
      //         icon: '',
      //         // icon: 'note-icon',
      //         measurement: '',
      //         format: 'text'
      //       },
      //     ],
      //     footerButton: {
      //       title: "Ver equipamentos associados",
      //       component: "FarmDAPTable",
      //       modalPrefix: "Cultivar"
      //     },
      //     "getDataFunc": async () => {
      //       ...
      //     },
      //     "deleteItemFunc": async (id) => soilUseCase().del.execute(id),
      //     "sortColumnsByKey": "measurement",
      //     "orderCardColumnsByDesc": true,
      //     "sideActionComponent": "SoilForm",
      //   }
      // },
      {
        componentName: "Equipments",
        routeName: "registers-equipments",
        path: "/equipments",
        title: "equipamentos",
        icon: "eqp-icon",
        needPermissionId: 3,
        needServiceId: null,
        description: "Cadastre equipamentos e seus modelos",
      },
      {
        componentName: "Devices",
        routeName: "registers-devices",
        path: "/devices",
        title: "dispositivos",
        icon: "dir-icon",
        needPermissionId: 4,
        needServiceId: null,
        description: "Cadastre dispositivos 3v3",
      },
      {
        componentName: "Route",
        routeName: "registers-routes",
        path: "/routes",
        title: "rotas",
        needPermissionId: 5,
        needServiceId: null,
        icon: "source-branch-icon",
        description: "Roteamento de dispositivos e sincronismo",
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/users",
        routeName: "registers-users",
        title: "usuários",
        needPermissionId: 6,
        needServiceId: null,
        icon: "active-user-icon",
        description: "Cadastre usuários",
        props: {
          pageTitles: ["Cadastrar", "Usuários"],
          cardTags: [],
          selectedTitle: "usuários",
          columns: [
            {
              title: "Cargo",
              key: "OLD_PERMISSION",
              icon: "briefcase-icon",
              format: "text",
            },
            {
              title: "Login",
              key: "LOGIN",
              icon: "active-user-icon",
              format: "text",
            },
            {
              title: "Grupo",
              key: "GROUP_NAME",
              icon: "user-group-icon",
              format: "text",
            },
          ],
          getDataFunc: async () => {
            const data = await users.list();
            data.forEach((user) => {
              user.OLD_PERMISSION =
                user.PERMISSION === 1 ? "Administrador" : "Usuário";
            });
            if (store.getters.isAdmin) {
              return [data];
            } else {
              if (store.state.userData.GROUP == null) {
                return [
                  data.filter((user) => user.ID === store.state.userData.ID),
                ];
              } else {
                return [
                  data.filter(
                    (user) => user.FK_GROUP === store.state.userData.GROUP
                  ),
                ];
              }
            }
            // if(store.getters.isAdmin) {
            //   return [data]
            // }
            // else {
            //   if (store.state.userData.GROUP == null) {
            //     return[  data.filter((user) => user.ID === store.state.userData.ID )]
            //   }
            //   else{
            //     return[  data.filter((user) => user.FK_GROUP === store.state.userData.GROUP )]
            //   }

            // }
            // return [
            //   data.map((user) => {
            //     user.OLD_PERMISSION =
            //       user.PERMISSION === 2 ? "Usuário" : "Administrador";

            //     return user;
            //   }),
            // ];
          },
          deleteItemFunc: async (id) => {
            const result = await users.del([{ ID: id }]);
            return result.failed ? null : [true];
          },
          sortColumnsByKey: "measurement",
          orderCardColumnsByDesc: true,
          sideActionComponent: "UserForm",
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/groups",
        routeName: "registers-groups",
        title: "grupos",
        needPermissionId: 6,
        needServiceId: null,
        icon: "user-group-icon",
        description: "Cadastre grupos de permissão para usuários",
        props: {
          pageTitles: ["Cadastrar", "Grupos"],
          cardTags: [],
          selectedTitle: "grupos",
          columns: [
            {
              title: "Membros associados",
              key: "usersLength",
              icon: "user-group-icon",
              measurement: "",
              format: "text",
            },
            {
              title: "Agendas associadas",
              key: "agnLength",
              icon: "calendar-clock-icon",
              measurement: "",
              format: "text",
            },
            {
              title: "Atuadores associados",
              key: "actuatorsLength",
              icon: "water-icon",
              measurement: "",
              format: "text",
            },
            {
              title: "Sensores associados",
              key: "sensorsLength",
              icon: "gauge-icon",
              measurement: "",
              format: "text",
            },
            // {
            //   title: "Data de Atualização",
            //   key: "UPDATE",
            //   icon: "calendar-icon",
            //   measurement: "",
            //   format: "date",
            // },
          ],
          footerButton: {
            title: "Associações",
            component: "GroupEquipamentsTable",
            modalPrefix: "Grupo",
            modalSize: "lg",
          },
          getDataFunc: async () => {
            const data = await users.groups.list();
            const relatedElements = await users.groups.relateds();
            const usersData = await users.list();

            const mapUsers = [];

            for (let i = 0; i < usersData.length; i++) {
              const user = usersData[i];
              // console.log(user)
              const groupId = user.FK_GROUP;

              if (groupId) {
                if (!mapUsers[groupId]) {
                  mapUsers[groupId] = [];
                }

                mapUsers[groupId].push(user);
              }
            }

            const mapAgn = [];
            for (let i = 0; i < relatedElements.agn.length; i++) {
              const agn = relatedElements.agn[i];
              // console.log(user)
              const groupId = agn.ID_GROUP;

              if (groupId) {
                if (!mapAgn[groupId]) {
                  mapAgn[groupId] = [];
                }

                mapAgn[groupId].push(agn);
              }
            }

            const mapValve = [];
            for (let i = 0; i < relatedElements.valve.length; i++) {
              const valve = relatedElements.valve[i];
              // console.log(user)
              const groupId = valve.ID_GROUP;

              if (groupId) {
                if (!mapValve[groupId]) {
                  mapValve[groupId] = [];
                }

                mapValve[groupId].push(valve);
              }
            }

            const mapPump = [];
            for (let i = 0; i < relatedElements.pump.length; i++) {
              const pump = relatedElements.pump[i];
              // console.log(user)
              const groupId = pump.ID_GROUP;

              if (groupId) {
                if (!mapPump[groupId]) {
                  mapPump[groupId] = [];
                }

                mapPump[groupId].push(pump);
              }
            }
            const mapHydro = [];
            for (let i = 0; i < relatedElements.hydro.length; i++) {
              const hydro = relatedElements.hydro[i];
              // console.log(user)
              const groupId = hydro.ID_GROUP;

              if (groupId) {
                if (!mapHydro[groupId]) {
                  mapHydro[groupId] = [];
                }

                mapHydro[groupId].push(hydro);
              }
            }
            const mapSensor = [];
            for (let i = 0; i < relatedElements.sensor.length; i++) {
              const sensor = relatedElements.sensor[i];
              // console.log(user)
              const groupId = sensor.ID_GROUP;

              if (groupId) {
                if (!mapSensor[groupId]) {
                  mapSensor[groupId] = [];
                }

                mapSensor[groupId].push(sensor);
              }
            }

            for (const group of data) {
              // Users
              group.USERS = mapUsers[group.ID] || [];
              group.usersLength = group.USERS
                ? `${group.USERS.length} membro(s)`
                : "0 membros";

              // schedules
              group.AGN = mapAgn[group.ID] || [];
              group.agnLength = group.AGN
                ? `${group.AGN.length} agenda(s)`
                : "0 agendas";

              // Actuactors
              group.VALVE = mapValve[group.ID] || []; //valves
              group.PUMP = mapPump[group.ID] || []; //pumps

              group.actuatorsLength = `${
                group.VALVE.length + group.PUMP.length
              } atuador(es)`;

              // Sensors
              group.SENSOR = mapSensor[group.ID] || []; //sensors
              group.HYDRO = mapHydro[group.ID] || []; //hydros
              group.sensorsLength = `${
                group.SENSOR.length + group.HYDRO.length
              } sensor(es)`;
            }

            if (store.getters.isAdmin) {
              return [data];
            } else {
              // UserGroup : ID do grupo em que o usuário logado está.
              const filtredGroup = data.filter(
                (group) => group.ID === store.state.userData.GROUP
              );
              return [filtredGroup];
            }
          },
          deleteItemFunc: async (id) => {
            const result = await users.groups.del([{ ID: id }]);
            return result.failed ? null : [true];
          },
          sortColumnsByKey: "measurement",
          orderCardColumnsByDesc: true,
          sideActionComponent: "GroupForm",
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/sectors",
        routeName: "registers-sectors",
        needPermissionId: 7,
        needServiceId: null,
        title: "setores",
        icon: "sector-icon",
        description: "Cadastre setores",
        props: {
          pageTitles: ["Cadastrar", "Setores"],
          selectedTitle: "setores",
          cardTags: [
            {
              icon: "code-not-equal-icon",
              title: "Setor de manejo",
              body: [
                {
                  title: "Data de plantio:  ",
                  key: "PLANTING_DATE",
                  format: "date",
                },
              ],
              tagValidator: (item) => item.IS_MANAGEMENT,
              class: "text-success",
            },
            {
              title: "Informações de edição",
              body: [
                {
                  title: "Última Atualização: ",
                  type: "edit date",
                  key1: "UPDATE",
                  format: "date",
                  key2: "EDITOR_NAME",
                },
                // {
                //   title: "Nome do editor: ",

                // },
              ],
              icon: "",
              icon: "calendar-icon",
              measurement: "",
              format: "date",
            },
          ],
          columns: [
            {
              title: "Area",
              key: "AREA",
              icon: "texture-icon",
              // icon: 'sector-icon',
              measurement: "ha",
              format: "float",
            },
            {
              title: "Fruto cultivado",
              key: "FARM_NAME",
              icon: "flower-icon",
              // icon: 'leaf-icon',
              measurement: "",
              format: "text",
            },
            // {
            //   title: "Data de Atualização",
            //   key: "UPDATE",
            //   icon: "",
            //   //  icon: 'calendar-icon',
            //   measurement: "",
            //   format: "date",
            // },
            // {
            //   title: "Nome do editor",
            //   key: "EDITOR_NAME",
            //   icon: "",
            //   // icon: 'note-icon',
            //   measurement: "",
            //   format: "text",
            // },
            {
              title: "Observações",
              key: "NOTE",
              icon: "note-icon",
              // icon: 'note-icon',
              measurement: "",
              format: "text",
            },
          ],
          footerButton: {
            title: "Equipamentos",
            component: "SectorEquipmentsTable",
            modalPrefix: "Setores",
            modalSize: "md",
          },
          getDataFunc: async () => {
            let managementSectors = [];

            // const managementAccess = !!(services.find(service => service.id == 1));
            const managementAccess = true;
            if (!store.getters.isAdmin) {
              return [];
            }

            if (managementAccess) {
              managementSectors =
                await managementSectorUseCases().show.execute();
            }

            let sectors_data = await sectors.list();

            if (
              managementAccess &&
              managementSectors[0].length &&
              sectors_data.length
            ) {
              for (let management_sector of managementSectors[0]) {
                let sector = sectors_data.find(
                  (sector) => sector.ID == management_sector.ID_SECTOR
                );

                if (sector) {
                  sector.DATE_CROP = management_sector.DATE_CROP;
                  sector.VOLUME_DATE = management_sector.VOLUME_DATE;
                  sector.OFFSET_DAP = management_sector.OFFSET_DAP;
                  sector.PRESSURIZE_TIME = management_sector.PRESSURIZE_TIME;
                  sector.TIME_ADVANCE = management_sector.TIME_ADVANCE;
                  sector.AVG_TIME_PULSE = management_sector.AVG_TIME_PULSE;
                  sector.APPLICATION_RATE = management_sector.APPLICATION_RATE;
                  sector.SYSTEM_EFFICIENCY =
                    management_sector.SYSTEM_EFFICIENCY;
                  sector.SPACING_BETWEEN_LINES =
                    management_sector.SPACING_BETWEEN_LINES;
                  sector.SPACING_BETWEEN_PLANTS =
                    management_sector.SPACING_BETWEEN_PLANTS;
                  sector.ID_SOIL = management_sector.ID_SOIL;
                  sector.ID_FARM = management_sector.ID_FARM;
                  sector.INITIAL_STORAGE = management_sector.INITIAL_STORAGE;
                  sector.IS_MANAGEMENT = Boolean(
                    management_sector.IS_MANAGEMENT
                  );
                }
              }
            }

            return [sectors_data];
          },
          deleteItemFunc: async (id) => {
            const result = await sectors.del([{ ID: id }]);

            return result.failed ? null : [true];
          },
          sortColumnsByKey: "measurement",
          orderCardColumnsByDesc: true,
          sideActionComponent: "SectorForm",
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/soil",
        routeName: "registers-soils",
        title: "solos",
        needPermissionId: 8,
        needServiceId: servicesRelations.management,
        icon: "sprout-icon",
        description: "Cadastre solos",
        props: {
          pageTitles: ["Cadastrar", "Solos"],
          selectedTitle: "solos",
          cardTags: [
            {
              title: "Data de Atualização",
              body: [
                {
                  title: "Última Atualização: ",
                  format: "date",
                  type: "edit date",
                  key1: "UPDATE",
                  key2: "EDITOR_NAME",
                },
              ],
              icon: "",
              icon: "calendar-icon",
              measurement: "",
              format: "date",
            },
          ],
          columns: [
            {
              title: "Transmissividade do Solo",
              key: "TRANSMISSIVITY",
              icon: "water-percent-icon",
              transformData: (val) => val * 100,
              measurement: "%",
              format: "float",
            },
            {
              title: "Capacidade de Campo",
              key: "FIELD_CAPACITY",
              transformData: (val) => val * 100,
              icon: "cup-water-icon",
              measurement: "%",
              format: "float",
            },
            {
              title: "Ponto de Murcha Permanente",
              key: "WILT_POINT",
              transformData: (val) => val * 100,
              icon: "cup-off-icon",
              measurement: "%",
              format: "float",
            },
            {
              title: "Densidade Aparente",
              key: "DENSITY",
              icon: "chart-bubble-icon",
              measurement: "g/cm³",
              format: "float",
            },
          ],

          checkBeforeDelete: [
            {
              identifierCheck: "s",
              type: "short",
              text1: "Existem solos",
              text2: "selecionados atualmente vinculados a setores de manejo",
              checkFunc: async (ids) => {
                const mapKey = "ID_SOIL";
                const sectorsUsing =
                  await soilUseCase().getSectorsWithSoil.execute(ids);
                const uniqueIdsOfItem = [
                  ...new Set(sectorsUsing.map((item) => item[mapKey])),
                ];

                return uniqueIdsOfItem;
              },
              dependentTitle: "setores",
              templateMessage: "hasData",
            },
          ],
          getDataFunc: async () => soilUseCase().show.execute(),
          deleteItemFunc: async (id) => soilUseCase().del.execute(id),
          sortColumnsByKey: "measurement",
          orderCardColumnsByDesc: true,
          sideActionComponent: "SoilForm",
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/farms_dap",
        routeName: "registers-farms-dap",
        title: "cultivares",
        needPermissionId: 9,
        needServiceId: servicesRelations.management,
        icon: "leaf-icon",
        description: "Cadastre cultivares",
        props: {
          restrictiveClose: true,
          pageTitles: ["Cadastrar", "Cultivares"],
          cardTags: [
            {
              title: "Data de Atualização",
              body: [
                {
                  title: "Última Atualização: ",
                  format: "date",
                  type: "edit date",
                  key1: "UPDATE",
                  key2: "EDITOR_NAME",
                },
              ],
              icon: "",
              icon: "calendar-icon",
              measurement: "",
              format: "date",
            },
          ],
          columns: [
            {
              title: "Lâmina de Transplantio",
              key: "LAMINA",
              icon: "leaf-icon",
              measurement: "mm",
              format: "float",
            },
            {
              title: "Observações",
              key: "NOTE",
              icon: "note-icon",
              measurement: "",
              format: "text",
            },
          ],
          checkBeforeDelete: [
            {
              type: "short",
              text1: "Existem cultivares",
              text2: "selecionados atualmente vinculados a setores de manejo",
              checkFunc: async (ids) => {
                const mapKey = "ID_FARM";
                const sectorsUsing =
                  await farmUseCase().getSectorsWithFarm.execute(ids);
                const uniqueIdsOfItem = [
                  ...new Set(sectorsUsing.map((item) => item[mapKey])),
                ];

                return uniqueIdsOfItem;
              },
            },
            {
              type: "short",
              text1: "Existem cultivares",
              text2: "selecionados atualmente vinculados com dados de planilha",
              checkFunc: async (ids) => checkFarmsWithData.execute(ids),
            },
          ],
          footerButton: {
            title: "Abrir planilha",
            component: "FarmDAPTable",
            modalPrefix: "Cultivar",
            modalSize: "xl",
          },
          getDataFunc: async () => farmUseCase().show.execute(),
          deleteItemFunc: async (id) => farmUseCase().del.execute(id),
          sortColumnsByKey: "measurement",
          orderCardColumnsByDesc: true,
          sideActionComponent: "FarmForm",
          selectedTitle: "cultivares",
          dependentTitle: "setores",
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/management-stations",
        routeName: "registers-mananagement-stations",
        title: "estações manejo",
        needPermissionId: 10,
        needServiceId: servicesRelations.management,
        icon: "station-icon",
        description: "Registre o histórico da estação para o manejo",
        props: {
          hideActions: true,
          restrictiveClose: true,
          pageTitles: ["Cadastrar", "Estações Manejo"],
          cardTags: [],
          columns: [
            // {
            //   title: "Latitude",
            //   key: "LATITUDE",
            //   icon: "dots-horizontal-circle-icon",
            //   measurement: "",
            //   format: "float",
            // },
            // {
            //   title: "Longitude",
            //   key: "LONGITUDE",
            //   icon: "dots-vertical-circle-icon",
            //   measurement: "",
            //   format: "float",
            // },
            {
              title: "Observações",
              key: "NOTE",
              icon: "note-icon",
              format: "text",
            },
          ],
          footerButton: {
            title: "Abrir planilha",
            component: "ManualStation",
            modalPrefix: "Estação",
            modalSize: "lg",
          },
          getDataFunc: getStations,
          sortColumnsByKey: "measurement",
          orderCardColumnsByDesc: true,
          sideActionComponent: "FarmForm",
          selectedTitle: "estação",
          dependentTitle: "setores",
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/alerts-dirs",
        title: "Alertas Dirs",
        routeName: "registers-alerts-dirs",
        needPermissionId: 11,
        needServiceId: servicesRelations.alerts,
        icon: "bell-icon",
        description: "Cadastre alertas de dispositivos",
        props: {
          pageTitles: ["Cadastrar", "Alertas de Dispositivos"],
          columns: [
            {
              title: "Alertas ativos",
              key: "ACTIVE_ALERTS",
              format: "join-concat-text",
              icon: "",
            },
            {
              title: "Bateria mínima permitida",
              key: "BAT_LOW_RANGE",
              icon: "",
              measurement: "V",
              format: "float",
            },
            {
              title: "Bateria máxima permitida",
              key: "BAT_HIGH_RANGE",
              icon: "",
              measurement: "V",
              format: "float",
            },
            {
              title: "Sinal mínimo permitido",
              key: "SIGNAL_LOW_RANGE",
              icon: "",
              measurement: "%",
              format: "float",
            },
          ],
          getDataFunc: async () => {
            const { data } = await alerts.getAllDirs();

            const formattedData = data.map((dir) => {
              dir.ID = dir.DIR_ID;
              dir.ACTIVE_ALERTS = ["Bateria", "Sinal"];
              dir.NAME = `DIR-${dir.ID}`;

              return dir;
            });

            return [formattedData];
          },
          sortColumnsByKey: "measurement",
          sideActionComponent: "DirForm",
          selectedTitle: "alertas de dispositivos",
          dependentTitle: "setores",
          hideCreate: true,
          hideDelete: true,
        },
      },
      {
        componentName: "RegisterPageTemplate",
        path: "/alerts-sensors",
        routeName: "registers-alerts-sensors",
        title: "Alertas Sensores",
        needPermissionId: 11,
        needServiceId: servicesRelations.alerts,
        icon: "bell-icon",
        description: "Cadastre alertas de sensores",
        props: {
          pageTitles: ["Cadastrar", "Alertas de Sensores"],
          columns: [
            {
              title: "Alertas ativos",
              key: "ACTIVE_ALERTS",
              format: "join-concat-text",
              icon: "",
            },
            {
              title: "Tempo de reenvio acima",
              key: "TIME_TO_RESEND_HIGH",
              icon: "",
              measurement: "min",
              format: "float",
            },
            {
              title: "Tempo de reenvio abaixo",
              key: "TIME_TO_RESEND_LOW",
              icon: "",
              measurement: "min",
              format: "float",
            },
            {
              title: "Tempo de tolerância acima",
              key: "TOLERANCE_HIGH",
              icon: "",
              measurement: "min",
              format: "float",
            },
            {
              title: "Tempo de tolerância abaixo",
              key: "TOLERANCE_LOW",
              icon: "",
              measurement: "min",
              format: "float",
            },
          ],
          getDataFunc: async () => {
            const { data } = await alerts.getAllSensors();

            const formattedData = data.map((sensor) => {
              sensor.ID = sensor.ID_ALERT;
              sensor.ACTIVE_ALERTS = sensor.RANGES.filter(
                (val) => (val.MAX || val.MAX == 0) && (val.MIN || val.MIN == 0)
              )
                .filter((val) => val.IS_RANGE_ACTIVE)
                .map((val) => val.TYPE_NAME);
              // TODO REMOVE THIS, AND CHANGE QUERY TO BRING THE NAME OF THE SENSOR
              // console.log({ sensor });

              return sensor;
            });
            console.log(formattedData);
            return [formattedData];
          },
          deleteItemFunc: async (id) => {
            const result = await alerts.deleteSensor(userStore.ID, {
              IDS: [id],
            });

            return result.failed ? null : [true];
          },
          sortColumnsByKey: "measurement",
          sideActionComponent: "AlertForm",
          selectedTitle: "alertas de sensores",
          dependentTitle: "setores",
        },
      },
    ],
  },
  {
    componentName: "DomainPageTemplate",
    path: "/reports",
    needPermissionId: null,
    needServiceId: null,
    title: "Relatórios",
    icon: "report-icon",
    description: "Relatórios",
    props: {
      pageTitle: "Relatórios",
      routesIndex: 2,
    },
    accentColor: "var(--green-3v3)",
    nestedRoutes: [
      {
        componentName: "Reports",
        path: "/all",
        needPermissionId: null,
        needServiceId: null,
        title: "Todos",
        icon: "report-icon",
        description: "Gere relatórios",
      },
    ],
  },
].map((route) => {
  route.fullPath = route.path;

  route.nestedRoutes.map((nestedRoute) => {
    nestedRoute.fullPath = route.path + nestedRoute.path;
    nestedRoute.accentColor = route.accentColor;
    if (nestedRoute.props) {
      //nestedRoute.props.hideActions = !isAdmin
      nestedRoute.props.icon = nestedRoute.icon;
      nestedRoute.props.accentColor = nestedRoute.accentColor;
    }

    return nestedRoute;
  });

  return route;
});

export const getFlatRoutes = (routesToFlat) => {
  const flatedRoutes = [];

  routesToFlat.forEach((rt) => {
    const route = { ...rt };

    route.nestedRoutes.forEach((nestedRoute) => {
      delete nestedRoute.nestedRoutes;

      flatedRoutes.push(nestedRoute);
    });

    delete route.nestedRoutes;
    flatedRoutes.push(route);
  });

  return flatedRoutes;
};

export const flatRoutes = getFlatRoutes(routes);

export const redirectTo = (redirectTo) => {
  window.open(redirectTo, "_blank");
};
